<template>
  <div>
    <Row>
      <Col :md="{ span: 16, offset: 4 }">
        <CreateServerMenu ref="CreateServerMenu"></CreateServerMenu>
        <Card shadow>
          <Alert show-icon type="error" v-if="errorMsg">{{ errorMsg }}</Alert>
          <Form :model="serverForm" ref="serverForm" :rules="serverRule" label-position="left" :label-width="200">
            <FormItem prop="availability_zone" label="区域">
              <RadioGroup v-model="serverForm.availability_zone" type="button">
                <Radio :label="item.zoneName" v-for="item in availabilityZoneList" :key="item.zoneName"></Radio>
              </RadioGroup>
            </FormItem>
            <FormItem prop="name" label="实例名称">
              <Input v-model="serverForm.name" style="max-width: 300px"/>
            </FormItem>
            <FormItem prop="bootStyle" label="启动源">
              <RadioGroup v-model="serverForm.bootStyle" type="button">
                <Radio :label="item.value" v-for="item in bootSourceStyles" :key="item.value">{{ item.label }}</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem prop="image" label="镜像" v-if="serverForm.bootStyle === 'image'">
              <Select v-model="serverForm.image" filterable transfer style="max-width: 300px" placeholder="请选择镜像">
                <Option v-for="item in imageList" :key="item.id" :value="item.id"
                        v-if="item.owner === $store.state.privateCloud.selPrivateCloudProject || item.visibility !== 'private'">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem prop="volume" label="云硬盘" v-if="serverForm.bootStyle === 'volume'">
              <Select v-model="serverForm.volume" filterable transfer style="max-width: 300px" placeholder="请选择云硬盘">
                <Option v-for="item in volumeList" :key="item.id" :value="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem prop="snapshot" label="云硬盘快照" v-if="serverForm.bootStyle === 'snapshot'">
              <Select v-model="serverForm.snapshot" filterable transfer style="max-width: 300px" placeholder="请选择云硬盘快照">
                <Option v-for="item in volumeSnapshotList" :key="item.id" :value="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem prop="flavor" label="规格">
              <RadioGroup v-model="serverForm.flavor" type="button">
                <Radio :label="item.id" v-for="item in flavorList" style="margin-bottom: 5px" :key="item.id">
                  <Tooltip transfer>
                    <div slot="content">
                      <p>
                        <span>内核：</span>
                        <span>{{ item.vcpus }}</span>
                      </p>
                      <p>
                        <span>内存：</span>
                        <span>{{ item.ram }} MB</span>
                      </p>
                      <p>
                        <span>根磁盘：</span>
                        <span v-if="item.disk">{{ item.disk }} GB</span>
                        <span v-else>0</span>
                      </p>
                      <p>
                        <span>临时磁盘：</span>
                        <span v-if="item['OS-FLV-EXT-DATA:ephemeral']">{{ item['OS-FLV-EXT-DATA:ephemeral'] }} GB</span>
                        <span v-else>0</span>
                      </p>
                      <p>
                        <span>Swap：</span>
                        <span v-if="item.swap">{{ item.swap }} GB</span>
                        <span v-else>0</span>
                      </p>
                    </div>
                    <span>{{ item.name }} - </span>
                    <span>{{ item.vcpus }}核</span>
                    <span v-if="item.ram >= 1024">{{ Math.floor(item.ram / 1024) }}G</span>
                    <span v-else>{{ item.ram }}M</span>
                  </Tooltip>
                </Radio>
              </RadioGroup>
              <p v-if="quota.ram || quota.cores">
                <span v-if="quota.ram">剩余内存配额：{{ ((quota.ram.limit - quota.ram.in_use) / 1024).toFixed(0) }} GB</span>
                <span v-if="quota.cores" style="padding-left: 10px">剩余内核配额：{{ quota.cores.limit - quota.cores.in_use }}</span>
              </p>
            </FormItem>
            <!--<FormItem prop="publicFlavor" label="规格">-->
              <!--<RadioGroup v-model="serverForm.publicFlavor" type="button">-->
              <!--<Radio :label="item.value" v-for="item in publicFlavors">{{ item.label }}</Radio>-->
              <!--</RadioGroup>-->
            <!--</FormItem>-->
            <FormItem prop="systemDisk" label="系统盘">
              <RadioGroup v-model="serverForm.systemDisk" type="button">
                <Radio :label="item.value" v-for="item in systemDiskStyles" :key="item.value">{{ item.label }}</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem prop="volume_size" label="系统盘大小" v-if="serverForm.systemDisk === 'volume'">
              <InputNumber :min="1" v-model="serverForm.volume_size"></InputNumber><b> GB</b>
            </FormItem>
            <FormItem prop="networks" label="网络">
              <Select v-model="serverForm.networks" style="max-width: 300px" placeholder="请选择网络" filterable transfer multiple>
                <Option v-for="item in networks" :key="item.id" :value="item.id"
                        v-if="item.tenant_id === $store.state.privateCloud.selPrivateCloudProject || item.shared">{{ item.name }} - {{ item['router:external'] ? '外网': '内网' }}</Option>
              </Select>
            </FormItem>
            <FormItem prop="securityGroup" label="安全组">
              <Select v-model="serverForm.securityGroup" style="max-width: 300px" placeholder="请选择安全组" filterable transfer>
                <Option v-for="item in securityGroupList" :key="item.id" :value="item.id">{{ item.name }}{{ item.description ? ` (${item.description})` : '' }}</Option>
              </Select>
            </FormItem>
            <FormItem prop="loginStyle" label="登录方式">
              <RadioGroup v-model="serverForm.loginStyle" type="button">
                <Radio :label="item.value" v-for="item in loginStyles" :key="item.value">{{ item.label }}</Radio>
              </RadioGroup>
              <p style="color: #999" v-if="serverForm.loginStyle === 'set_password'">
                <span>需要镜像支持，否则密码无效！</span>
              </p>
              <p style="color: #999" v-else-if="serverForm.loginStyle === 'auto_password'">
                <span>需要镜像支持，否则密码无效！</span>
                <span>创建后，自动生成的密码将通过页面返回给您，密码只显示一次，请妥善保管。</span>
              </p>
            </FormItem>
            <FormItem prop="adminPass" label="管理员密码" v-if="serverForm.loginStyle === 'set_password'">
              <Input v-model="serverForm.adminPass" style="max-width: 300px" type="password"/>
            </FormItem>
            <FormItem prop="adminPass2" label="确认密码" v-if="serverForm.loginStyle === 'set_password'">
              <Input v-model="serverForm.adminPass2" style="max-width: 300px" type="password"/>
            </FormItem>
            <FormItem prop="securityGroup" label="密钥" v-if="serverForm.loginStyle === 'bind_key'">
              <Select v-model="serverForm.key_pair" style="max-width: 300px" placeholder="请选择密钥" filterable transfer>
                <Option v-for="item in keyPairList" :key="item.name" :value="item.name">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem prop="min_count" label="创建实例数量">
              <InputNumber
                v-model="serverForm.min_count"
                :min="quota.instances ? (quota.instances.limit === -1 ? 1 : (quota.instances.limit - quota.instances.in_use <= 0 ? 0 : 1)) : 1"
                :max="quota.instances ? (quota.instances.limit === -1 ? 10 : quota.instances.limit - quota.instances.in_use) : 10 "></InputNumber>
              <span v-if="quota.instances" style="padding-left: 10px">剩余配额：{{ quota.instances.limit - quota.instances.in_use }}</span>
            </FormItem>
            <FormItem prop="user_data" label="执行脚本">
              <Input type="textarea" v-model="serverForm.user_data" maxlength="16384" show-word-limit/>
            </FormItem>
          </Form>
          <Divider/>
          <div style="text-align: right">
            <Button type="primary" @click="submitCreateServer" :loading="submitLoading">立即创建</Button>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { getPrivateCloudAllFlavor } from '@/api/private-cloud/flavor'
import { getPrivateCloudAllImage } from '@/api/private-cloud/image'
import { getPrivateCloudAllVolume } from '@/api/private-cloud/volume'
import { getPrivateCloudAllVolumeSnapshot } from '@/api/private-cloud/volume-snapshot'
import { getPrivateCloudAllNetwork } from '@/api/private-cloud/network'
import { getPrivateCloudAvailabilityZones } from '@/api/private-cloud/availability-zone'
import { getPrivateCloudAllSecurityGroup } from '@/api/private-cloud/security-group'
import { getPrivateCloudAllKeyPair } from '@/api/private-cloud/keypair'
import { getPrivateCloudCurrentProjectComputeQuota } from '@/api/private-cloud/quota-compute'
import { changePrivateCloudServer } from '@/api/private-cloud/server'
import CreateServerMenu from './components/create-menu'

export default {
  name: 'create-server-fast',
  components: {
    CreateServerMenu
  },
  data () {
    return {
      serverForm: {
        availability_zone: '',
        name: '',
        bootStyle: 'image',
        image: '',
        volume: '',
        snapshot: '',
        flavor: '',
        publicFlavor: 'cpu:1|mem:2',
        systemDisk: 'local',
        volume_size: 40,
        networks: [],
        securityGroup: '',
        loginStyle: 'bind_key',
        adminPass: '',
        adminPass2: '',
        key_pair: '',
        min_count: 1,
        user_data: ''
      },
      serverRule: {
        name: { required: true, message: '请填写实例名称', trigger: 'blur' },
        bootStyle: { required: true, message: '请选择启动源', trigger: 'change' },
        image: { required: true, message: '请选择镜像', trigger: 'change' },
        volume: { required: true, message: '请选择云硬盘', trigger: 'change' },
        snapshot: { required: true, message: '请选择云硬盘快照', trigger: 'change' },
        availability_zone: { required: true, message: '请选择部署的区域', trigger: 'change' },
        flavor: { required: true, message: '请选择规格', trigger: 'change' },
        publicFlavor: { required: true, message: '请选择规格', trigger: 'change' },
        systemDisk: { required: true, message: '请选择系统盘', trigger: 'change' },
        volume_size: { required: true, message: '请填写系统盘大小', trigger: 'blur', type: 'number' },
        networks: { required: true, message: '至少选择一个网络', type: 'array' },
        securityGroup: { required: true, message: '请选择安全组', trigger: 'change' },
        adminPass: [
          { required: true, message: '请填写管理员密码', trigger: 'blur' },
          {type: 'string', min: 8, message: '密码长度不能小于 8 位', trigger: 'blur'},
          {
            pattern: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/,
            message: '密码必须包含至少一位大写，小写，数字，特殊字符',
            trigger: 'blur'
          }
        ],
        adminPass2: { required: true, message: '', trigger: 'blur', validator: this.validPasswordRule },
        key_pair: { required: true, message: '请选择密钥', trigger: 'change' },
        min_count: { required: true, message: '请填写要创建的实例数量', trigger: 'blur', type: 'number' }
      },
      bootSourceStyles: [
        { label: '镜像', value: 'image' },
        { label: '云硬盘', value: 'volume' },
        { label: '云硬盘快照', value: 'snapshot' }
      ],
      publicFlavors: [
        { label: '1核2G', value: 'cpu:1|mem:2' },
        { label: '2核4G', value: 'cpu:2|mem:4' },
        { label: '4核8G', value: 'cpu:4|mem:8' },
        { label: '8核16G', value: 'cpu:8|mem:16' },
        { label: '16核32G', value: 'cpu:16|mem:32' }
      ],
      systemDiskStyles: [
        { label: '本地硬盘', value: 'local' },
        { label: '云硬盘', value: 'volume' }
      ],
      localDiskStyles: [
        { label: '40GB', value: 40 },
        { label: '60GB', value: 60 }
      ],
      loginStyles: [
        { label: '设置密码', value: 'set_password' },
        { label: '自动生成密码', value: 'auto_password' },
        { label: '关联密钥', value: 'bind_key' }
      ],
      flavorList: [],
      imageList: [],
      volumeList: [],
      volumeSnapshotList: [],
      availabilityZoneList: [],
      networks: [],
      securityGroupList: [],
      keyPairList: [],
      quota: {},
      submitLoading: false,
      errorMsg: null
    }
  },
  created: function () {
    this.getAllFlavorList()
    this.getAllImageList()
    // this.getVolumeList()
    // this.getVolumeSnapshotList()
    this.getAvailabilityZoneListData()
    this.getNetworkListData()
    this.getSecurityGroupListData()
    this.getKeyPairListData()
    this.getQuota()
  },
  methods: {
    // 获取所有实例类型列表
    getAllFlavorList () {
      getPrivateCloudAllFlavor({ordering: 'vcpus'}).then(res => {
        this.flavorList = res.data
        if (res.data.length) {
          this.serverForm.flavor = res.data[0].id
        }
      }).catch(res => {
        console.log(res.response)
        this.$Notice.error({
          title: '获取规格列表失败！'
        })
      })
    },
    // 获取所有镜像列表
    getAllImageList () {
      getPrivateCloudAllImage().then(res => {
        this.imageList = res.data
        if (this.$route.query.defaultImage) {
          this.serverForm.image = this.$route.query.defaultImage
        } else if (res.data.length) {
          this.serverForm.image = res.data[0].id
        }
      }).catch(res => {
        this.$Notice.error({
          title: '获取镜像列表失败！'
        })
      })
    },
    // 获取云硬盘列表
    getVolumeList () {
      getPrivateCloudAllVolume().then(res => {
        this.volumeList = []
        for (let i in res.data) {
          if (res.data[i].status === 'available' && res.data[i].bootable === 'true') {
            this.volumeList.push(res.data[i])
          }
        }
      }).catch(res => {
        this.$Notice.error({
          title: '获取云硬盘列表失败！'
        })
      })
    },
    // 获取云硬盘快照列表
    getVolumeSnapshotList () {
      getPrivateCloudAllVolumeSnapshot().then(res => {
        this.volumeSnapshotList = res.data
      }).catch(res => {
        this.$Notice.error({
          title: '获取云硬盘快照列表失败！'
        })
      })
    },
    // 获取可用域列表
    getAvailabilityZoneListData () {
      getPrivateCloudAvailabilityZones().then(res => {
        this.availabilityZoneList = res.data
        if (res.data.length) {
          this.serverForm.availability_zone = res.data[0].zoneName
        }
      }).catch(res => {
        this.$Notice.error({
          title: '获取可用域列表失败！'
        })
      })
    },
    // 获取虚拟内网列表
    getNetworkListData () {
      getPrivateCloudAllNetwork().then(res => {
        this.networks = res.data
      }).catch(res => {
        this.$Notice.error({
          title: '获取网络列表失败！'
        })
      })
    },
    // 获取安全组列表
    getSecurityGroupListData () {
      getPrivateCloudAllSecurityGroup().then(res => {
        this.securityGroupList = res.data
        for (let i in res.data) {
          if (res.data[i].name === 'default') {
            this.serverForm.securityGroup = res.data[i].id
            break
          }
        }
      }).catch(res => {
        this.$Notice.error({
          title: '获取安全组列表失败！'
        })
      })
    },
    // 二次确认密码规则
    validPasswordRule (rule, value, callback) {
      if (!this.serverForm.adminPass) {
        callback(new Error('确认密码不能为空'))
      } else if (this.serverForm.adminPass !== this.serverForm.adminPass2) {
        callback(new Error('两次输入的密码不同'))
      } else {
        callback()
      }
    },
    // 获取密钥对列表
    getKeyPairListData () {
      getPrivateCloudAllKeyPair().then(res => {
        this.keyPairList = res.data
      }).catch(res => {
        this.$Notice.error({
          title: '获取密钥对列表失败！'
        })
      })
    },
    getQuota () {
      getPrivateCloudCurrentProjectComputeQuota().then(res => {
        this.quota = res.data.quota_set
      }).catch(res => {
        console.log(res.response)
      })
    },
    submitCreateServer () {
      this.$refs.serverForm.validate((valid) => {
        if (valid) {
          let reqData = {
            name: this.serverForm.name,
            availability_zone: this.serverForm.availability_zone,
            block_device_mapping_v2: [
              {
                boot_index: 0,
                source_type: this.serverForm.bootStyle,
                delete_on_termination: false
              }
            ],
            networks: this.serverForm.networks.map(item => {
              return {uuid: item}
            }),
            flavorRef: this.serverForm.flavor,
            min_count: this.serverForm.min_count
          }
          if (this.serverForm.bootStyle === 'image') {
            reqData.block_device_mapping_v2[0].uuid = this.serverForm.image
            reqData.imageRef = this.serverForm.image
            if (this.serverForm.systemDisk === 'volume') {
              reqData.block_device_mapping_v2[0].destination_type = 'volume'
              reqData.block_device_mapping_v2[0].volume_size = this.serverForm.volume_size
            } else if (this.serverForm.systemDisk === 'local') {
              reqData.block_device_mapping_v2[0].destination_type = 'local'
              reqData.block_device_mapping_v2[0].no_device = true
            }
          } else if (this.serverForm.bootStyle === 'volume') {
            reqData.block_device_mapping_v2[0].destination_type = 'volume'
            reqData.block_device_mapping_v2[0].uuid = this.serverForm.volume
          } else if (this.serverForm.bootStyle === 'snapshot') {
            reqData.block_device_mapping_v2[0].destination_type = 'volume'
            reqData.block_device_mapping_v2[0].uuid = this.serverForm.snapshot
          }
          if (this.serverForm.securityGroup) {
            reqData.security_groups = [
              { name: this.serverForm.securityGroup }
            ]
          }
          if (this.serverForm.loginStyle === 'bind_key') {
            reqData.key_name = this.serverForm.key_pair
          } else if (this.serverForm.loginStyle === 'set_password') {
            reqData.adminPass = this.serverForm.adminPass
          }
          if (this.serverForm.user_data) {
            reqData.user_data = window.btoa(this.serverForm.user_data)
          }
          this.submitLoading = true
          changePrivateCloudServer(reqData).then(res => {
            this.$router.push({'name': 'server'})
            if (this.serverForm.loginStyle === 'auto_password') {
              this.$Modal.success({
                title: '实例创建成功',
                content: `实例密码：${res.data.server.adminPass}`
              })
            } else {
              this.$Notice.success({
                title: '实例创建成功！'
              })
            }
            this.$refs.serverForm.resetFields()
            this.submitLoading = false
          }).catch(res => {
            this.submitLoading = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
              this.errorMsg = res.response.data
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
